import Snackbar from "../../snackbar/Snackbar";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import {_transl, t} from "../../../../../store/localization/TranslMessasge";
import {DataTypeTranslationKey} from "../DataTypeTranslationKey";
import DeleteConfirmationDialog from "../../../../../components/dialogs/DeleteConfirmationDialog";
import {DataTypeApiClient} from "../../../../../common/apis/datatype/DataTypeApiClient";
import {useRef, useState} from "react";

export interface DataTypeConstraintDeleteDialogProps {
    open: boolean;
    dataTypeDefinitionId: string;
    constraintId?: string;
    onClose: () => void;
    onDeleted: () => void;
}

export default function DataTypeConstraintDeleteDialog(props: Readonly<DataTypeConstraintDeleteDialogProps>) {
    const {open, dataTypeDefinitionId, constraintId, onClose, onDeleted} = props;

    const dataTypeApiClient = useRef(new DataTypeApiClient());
    const [deleteInProgress, setDeleteInProgress] = useState<boolean>(false);

    function deleteConstraint(constraintId: string) {
        setDeleteInProgress(true);
        dataTypeApiClient.current.deleteConstraint(dataTypeDefinitionId, constraintId)
            .then(() => {
                onDeleted();
                onClose();
                Snackbar.success(t(DataTypeTranslationKey.CONSTRAINT_DELETED_SUCCESSFULLY));
            })
            .catch((error) => Snackbar.error(_transl(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error))
            .finally(() => setDeleteInProgress(false));
    }

    if (!constraintId) {
        return null;
    }

    return (
        <DeleteConfirmationDialog
                open={open}
                title={_transl(DataTypeTranslationKey.DELETE_CONSTRAINT_PROMPT)}
                message={_transl(DataTypeTranslationKey.CONSTRAINT_WILL_BE_DELETED)}
                deleteDisabled={deleteInProgress}
                onDelete={() => deleteConstraint(constraintId)}
                onDismiss={onClose} />
    );
}